/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'

import React from 'react'
import {default as useScatterGraph, ContextProvider} from './use-scatter-graph'
import {Loading, } from '../../twd/twd'
import Chart from './chart'
import Table from './table'
import { CriteriaForm, CriteriaTags } from './criteria'
import { BenchmarkLegends } from './benchmark'

export default () => {
    return <ContextProvider>
        <Main />
    </ContextProvider>
}

const Main = ()  => {
    const { offersStatus, offersError } = useScatterGraph()

    return <React.Fragment>
    <div id="scatter-graph-offering-search" className="vertical-offset-sm"></div>

    <div data-name='municipals-scatter-graph-offering-search' className="container vertical-offset-sm" css={sectionCss}>
        <div className="row vertical-offset-sm"></div>
        <div className="row">
        <div className="col-md-12 col-xs-12">
            <h3 className="medium-header">Scatter Graph Offering Search</h3>
        </div>
        </div>

        <div className="row">
        <div className="col-md-12">
            <CriteriaForm />
        </div></div>

        <Loading status={offersStatus} error={offersError}>
            <div className="row">
            <div className="col-xs-12" style={{position:'relative'}}>
                <figure>
                <div aria-hidden="true">
                    <Chart />
                </div>
                <figcaption className="screen-reader-only">
                    <Table />
                </figcaption>
                </figure>

                <div style={{position:'absolute', top:0, zIndex:2}}>
                <CriteriaTags />
                </div>

            </div>
            </div>

            <BenchmarkLegends />
        </Loading>
    </div>
    </React.Fragment>
}
